import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { workspacePath } from '@wrapforce/shared/api-client';
import { api } from '@/lib/api';
import type { AssistantUsage, ExecuteActionResult } from './types';

export function useExecuteAction(workspaceId: string | null) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (actionId: string) =>
      api.post<ExecuteActionResult>(workspacePath(workspaceId!, `/assistant/actions/${actionId}/execute`)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [workspaceId] });
    },
  });
}

export function useAssistantUsage(workspaceId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: [workspaceId, 'assistant', 'usage'],
    queryFn: () => api.get<AssistantUsage>(workspacePath(workspaceId!, '/assistant/usage')),
    enabled: !!workspaceId && enabled,
    staleTime: 0,
  });
}
